<template>
  <div class="sc">
    <div class="sc__top">
      <div class="sc__title" v-if="title">{{ title }}</div>
      <div class="sc__icon" v-if="$slots.icon">
        <slot name="icon" />
      </div>
    </div>

    <div class="sc__value">
      <slot />
    </div>

    <div class="sc__sub" v-if="sub">{{ sub }}</div>

    <!-- optional: tiny hint line -->
    <div class="sc__hint" v-if="$slots.hint">
      <slot name="hint" />
    </div>
  </div>
</template>

<script>
export default { props: { title: String, sub: String } }
</script>

<style scoped>
.sc{
  background:#fff;
  border:1px solid rgba(0,0,0,.08);
  border-radius:16px;
  padding:14px;
  box-shadow: 0 10px 30px rgba(0,0,0,.04);
  position:relative;
  overflow:hidden;
}
.sc:before{
  content:"";
  position:absolute;
  inset:0;
  background: linear-gradient(180deg, rgba(17,24,39,.03), rgba(255,255,255,0));
  pointer-events:none;
}

.sc__top{
  display:flex;
  align-items:flex-start;
  justify-content:space-between;
  gap:10px;
  position:relative;
}

.sc__title{
  font-size:12px;
  font-weight:900;
  letter-spacing:.06em;
  text-transform:uppercase;
  color: rgba(0,0,0,.55);
}

.sc__icon{
  width:32px;
  height:32px;
  border-radius:12px;
  display:flex;
  align-items:center;
  justify-content:center;
  background: rgba(0,0,0,.04);
  border:1px solid rgba(0,0,0,.06);
}

.sc__value{
  margin-top:10px;
  font-size:24px;
  font-weight:1000;
  letter-spacing:-.2px;
  color:#111827;
  position:relative;
}

.sc__sub{
  margin-top:6px;
  font-size:12px;
  font-weight:800;
  color: rgba(0,0,0,.55);
  position:relative;
}

.sc__hint{
  margin-top:10px;
  font-size:12px;
  opacity:.75;
  position:relative;
}
</style>
